/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {reInitializeAdminSchedules} from './admin-maintenance-schedules';
import {reInitializeAdminMaintenanceServices} from './admin-maintenance-services';

// defines the valid admin maintenance tab indices ...
export enum AdminMaintenanceTab {
  SCHEDULES = 0,
  SERVICES = 1
}

// defines the setSelectedTab action type ...
export interface SetSelectedTabAction {
  type: string
  selectedTab: AdminMaintenanceTab
};

export const SET_SELECTED_ADMIN_MAINTENANCE_TAB = 'SET_SELECTED_ADMIN_MAINTENANCE_TAB';
export const RE_INITIALIZE_ADMIN_MAINTENANCE    = 'RE_INITIALIZE_ADMIN_MAINTENANCE';

/**
 * @setSelectedTab
 *
 * Invoked when the selected admin maintenance tab changes.
 */
export const setSelectedTab = (selectedTab: AdminMaintenanceTab): SetSelectedTabAction => ({
  type : SET_SELECTED_ADMIN_MAINTENANCE_TAB, selectedTab
});

export const reInitializeAdminMaintenance = () => {
  return (dispatch) => {
    dispatch({type: RE_INITIALIZE_ADMIN_MAINTENANCE});
    dispatch(reInitializeAdminMaintenanceServices());
    dispatch(reInitializeAdminSchedules());
  };
};
